/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Type_NoteInputs */



/**
* | output |
* | --- |
* | "General Note" |
*
* @param {Manual_Qc_Type_NoteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_type_note = /** @type {((inputs?: Manual_Qc_Type_NoteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Type_NoteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Note generale")
	if (locale === "de") return /** @type {LocalizedString} */ ("Allgemeine Anmerkung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nota generale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Общее примечание")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nota general")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("一般说明")
	if (locale === "ja") return /** @type {LocalizedString} */ ("一般的な注意事項")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सामान्य नोट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nota geral")
	return /** @type {LocalizedString} */ ("General Note")
});